import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import IntlMessages from '../../components/utility/intlMessages';
import TopbarDropdownWrapper, { TopBarUserIcon } from './topbarDropdown.style';
import { Avatar } from './style';

import {
  IconButtons,
  TopbarDropdown,
  UserInformation,
  SettingsList,
  Icon,
} from './topbarDropdown.style';
import authAction from '../../redux/auth/actions';
// import Image from '../../images/user.jpg';

const { logout } = authAction;

const theme = createMuiTheme({
  overrides: {
    MuiModal: {
      root: {
        zIndex: 1800,
      },
    },
    MuiPopover: {
      paper: {
        maxWidth: 290,
      },
    },
  },
});

class TopbarUser extends Component {

  state = {
    visible: false,
    anchorEl: null,
    firstname: '',
    lastname: '',
    email: ''
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.userData.user && nextProps.userData.user.firstname !== prevState.firstname ) {
      return {
        firstname: nextProps.userData.user.firstname,
        lastname: nextProps.userData.user.lastname,
        email: nextProps.userData.user.email
      };
    }
  }
  
  hide = () => {
    this.setState({ visible: false });
  };

  userInitials = () => {
    if( this.state.firstname && this.state.lastname) {
      return this.state.firstname.charAt(0).toUpperCase() + this.state.lastname.charAt(0).toUpperCase();
    }
    return '';
  };

  handleVisibleChange = () => {
    this.setState({
      visible: !this.state.visible,
      anchorEl: findDOMNode(this.button),
    });
  };

  render() {
    const theTheme = theme;
    const content = (
      <TopbarDropdown>
        <UserInformation>
          <div className="userImage">
            <Avatar className="blueAvatar">
              <Icon>person</Icon>
            </Avatar>
          </div>
          <div className="userDetails">
            <h3>{!_.isEmpty(this.props.userData) ? this.props.userData.user.firstname : ''} {!_.isEmpty(this.props.userData) ? this.props.userData.user.lastname : ''}</h3>
          </div>
        </UserInformation>

        <SettingsList>
          <Link to="/dashboard/profile" className="dropdownLink">
            <Icon>settings</Icon>
            <IntlMessages id="themeSwitcher.settings" />
          </Link>
          <a className="dropdownLink">
            <Icon>help</Icon>
            <IntlMessages id="topbar.help" />
          </a>
          <Link to="/" onClick={this.props.logout} className="dropdownLink">
            <Icon>input</Icon>
            <IntlMessages id="topbar.logout" />
          </Link>
        </SettingsList>
      </TopbarDropdown>
    );

    const dropDownVisible = this.state.visible ? 'dropDownVisible' : '';

    return (
      <TopBarUserIcon id="topbarUserIcon" className={`${dropDownVisible}`}>
        <IconButtons
          ref={node => {
            this.button = node;
          }}
          variant="outlined"
          size="small"
          disableRipple={true}
          onClick={this.handleVisibleChange}
          className="userIcon"
        >
          <div className="userImgWrapper">
            <Avatar className="blueAvatar">
              <Icon>person</Icon>
            </Avatar>
          </div>
          <div className="userEmail">
            {`${this.state.firstname} ${this.state.lastname}`}
          </div>
          <Icon className={`userDropDownIcon`}>keyboard_arrow_down</Icon>
        </IconButtons>
        <MuiThemeProvider theme={theme}>
          <TopbarDropdownWrapper
            open={this.state.visible}
            anchorEl={this.state.anchorEl}
            onClose={this.hide}
            // marginThreshold={66}
            className="userPopover"
            anchorOrigin={{
              horizontal: 'right',
            }}
            transformOrigin={{
              horizontal: 'right',
            }}
          >
            {content}
          </TopbarDropdownWrapper>
        </MuiThemeProvider>
      </TopBarUserIcon>
    );
  }
}

export default connect(
  state => ({
    ...state.App,
    customizedTheme: state.ThemeSwitcher.topbarTheme,
  }),
  { logout }
)(TopbarUser);



// WEBPACK FOOTER //
// ./src/containers/Topbar/topbarUser.js